

const MenuMobile = () => (
  <nav>
    <ul className="list-unstyled d-flex flex-column align-items-center mt-3">
      <li className="mb-4">
        <a href="#pratice-areas" className="text-decoration-none light-text-color">
          Practice areas
        </a>
      </li>
      <li className="mb-4">
        <a href="#pratice-advice" className="text-decoration-none light-text-color">
          Practice advice
        </a>
      </li>
      <li className="mb-4">
        <a href="#who-we-are" className="text-decoration-none light-text-color">
          Who we are
        </a>
      </li>
      <li className="mb-4">
        <a href="#contact-us" className="text-decoration-none light-text-color">
          contact us
        </a>
      </li>
    </ul>
  </nav>
);

export default MenuMobile;
